// extracted by mini-css-extract-plugin
export var emoji = "m_bp";
export var size21 = "m_bq";
export var size24 = "m_br";
export var size27 = "m_bs";
export var size32 = "m_bt";
export var text = "m_bv";